/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable import/prefer-default-export */
import { PropertyOccupant, PropertyWithOccupants } from '@centecomm/portal-service';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { ArrowDownCircle, ArrowUpCircle } from '../../../Icons';
import styles from './property-tenant-selection-header.module.css';

interface PropertyTenantSelectionHeaderProps {
    listActive: boolean;
    handler: () => void;
    propertyOrOccupants?: PropertyWithOccupants[] | PropertyOccupant[];
    type: 'Tenant' | 'Property' | 'Company' | 'T' | 'P' | 't' | 'p' | 'Space';
    withMargin?: boolean;
    listDisabled?: boolean;
    placeholderOverride?: string;
}

export const PropertyTenantSelectionHeader: React.FC<PropertyTenantSelectionHeaderProps> = ({
    listActive,
    handler,
    propertyOrOccupants = [],
    type,
    withMargin = false,
    listDisabled = false,
    placeholderOverride,
}) => {
    const { t } = useTranslation(['forms']);
    const [selectionType, setSelectionType] = React.useState<'Tenant' | 'Property' | 'Company' | 'Space'>();
    const translatedType = useMemo(() => t(`forms:selectors.generic.type.${selectionType?.toLowerCase()}`), [selectionType]);

    React.useEffect(() => {
        const theType = type.toLocaleLowerCase();

        if (theType === 'p' || theType === 'property') {
            setSelectionType('Property');
        } else if (theType === 't' || theType === 'tenant') {
            setSelectionType('Tenant');
        } else if (theType === 'space') {
            setSelectionType('Space');
        } else if (theType === 'company') {
            setSelectionType('Company');
        }
    }, [propertyOrOccupants, type]);

    const label = React.useMemo(() => {
        const filteredPropertyOrOccupants = propertyOrOccupants.filter((_) => _);

        if (filteredPropertyOrOccupants.length === 0) {
            return placeholderOverride || t('forms:selectors.generic.clickToSelect', { type: translatedType });
        }
        if (filteredPropertyOrOccupants.length === 1) {
            return `${translatedType}: ${propertyOrOccupants[0].name}`;
        }
        return t('forms:selectors.generic.selected', { type: translatedType, count: propertyOrOccupants.length });
    }, [propertyOrOccupants, placeholderOverride, translatedType]);

    return (
        <>
            {selectionType && (
                <div
                    className={`${styles.PropertyTenantSelectionHeader} ${withMargin ? styles.WithMargin : ''} `}
                    onClick={handler}
                    data-qa={`property-tenant-selection-header-${type}`}
                >
                    <p data-qa={`select-${selectionType}-label`}>{label}</p>
                    {!listDisabled ? listActive ? <ArrowUpCircle /> : <ArrowDownCircle /> : null}
                </div>
            )}
        </>
    );
};

export default PropertyTenantSelectionHeader;
